import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { Bell, X, AlertTriangle, Tag, Sparkles } from "lucide-react";

const KIND_STYLES = {
  info: { bg: "bg-[#0F0F0F]", text: "text-[#FDFCF8]", accent: "text-[#FDFCF8]", icon: Bell },
  warn: { bg: "bg-[var(--brand-primary)]", text: "text-white", accent: "text-white", icon: AlertTriangle },
  promo: { bg: "bg-[#FDFCF8] border-y border-[#0F0F0F]", text: "text-[#0F0F0F]", accent: "text-[var(--brand-primary)]", icon: Sparkles },
  discount: { bg: "bg-[#F3F2EB] border-y border-[#0F0F0F]", text: "text-[#0F0F0F]", accent: "text-[var(--brand-primary)]", icon: Tag },
};

export default function AnnouncementBanner() {
  const [items, setItems] = useState([]);
  const location = useLocation();
  const [dismissed, setDismissed] = useState(() => {
    try { return JSON.parse(localStorage.getItem("dismissed_announcements") || "[]"); } catch { return []; }
  });

  // Refetch on every route change AND every 30s.
  useEffect(() => {
    let alive = true;
    const fetch = () => api.get("/announcements")
      .then((r) => { if (alive) setItems(r.data || []); })
      .catch(() => {});
    fetch();
    const t = setInterval(fetch, 30000);
    return () => { alive = false; clearInterval(t); };
  }, [location.pathname]);

  const visible = items.filter((a) => !dismissed.includes(a.announcement_id));
  if (visible.length === 0) return null;

  const dismiss = (id) => {
    const next = [...dismissed, id];
    setDismissed(next);
    try { localStorage.setItem("dismissed_announcements", JSON.stringify(next)); } catch {}
  };

  return (
    <div data-testid="announcement-banner" className="w-full">
      {visible.slice(0, 3).map((a) => {
        const s = KIND_STYLES[a.kind] || KIND_STYLES.info;
        const Icon = s.icon;
        return (
          <div
            key={a.announcement_id}
            data-testid={`announcement-${a.announcement_id}`}
            className={`${s.bg} ${s.text} px-6 lg:px-10 py-2.5 flex items-center gap-3 text-sm`}
          >
            <Icon className={`w-4 h-4 flex-shrink-0 ${s.accent}`} />
            <div className="flex-1 min-w-0">
              <span className="font-semibold mr-2">{a.title}</span>
              {a.body && <span className="opacity-80">{a.body}</span>}
            </div>
            <button
              onClick={() => dismiss(a.announcement_id)}
              className="opacity-70 hover:opacity-100 flex-shrink-0"
              aria-label="Dismiss"
              data-testid={`dismiss-${a.announcement_id}`}
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
